<template>
    <div class="inline-block">
        <div class="inline-block">分管商户</div>
        <el-select class="width-1-5x" v-model="merchantId" filterable placeholder="请选择" @change="merchantChange">
            <el-option v-for="item in merchantList" :key="item.id" :label="item.name" :value="item.id"/>
        </el-select>
    </div>

</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox } from '../../app.vues'

    import merchtAllApi from '../../api/merchtAll'

    export default {
        name: 'swb-mercht-select-popover',
        desc: '分管商户选择组件',
        props: {
            merchantType: { // 商户类型
                type: String,
                default: 'retailer'
            },
            defSelect: { // 是否默认选中第一个,并触发一次回调
                type: Boolean,
                default: false
            },
            selectHandler: { // 切换商户回调
                type: Function
            },
            defSelectId : {
                type: Number,
                default: null
            }
        },
        watch: {},
        data: function () {
            return {
                merchantList: [],
                merchantId: null,
                merchant: null
            }
        },
        created: function () {
            this.merchantId = this.defSelectId;
            if (typeof this.selectHandler != 'function') {
                MsgBox.warning('没有回调方法');
            }
            this.getMerchtList();
        },
        methods: {
            getMerchtList(){
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: 99999,
                    pageNumber: 1,
                };
                //
                let filterItems = {};
                let sortItemList = [];
                let sortItems = {};
                //
                filterItems.selectType = self.merchantType;
                filterItems.virtual = false;
                filterItems.disabled = false;
                //
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                //
                let theLoading = MsgBox.loading();
                // 调用查询接口
                merchtAllApi.getMerchantDtoPageList(postData, function (result) {
                    theLoading.close();
                    if (result.type == 'info') {
                        self.merchantList = result.data.rows || [];
                        if (self.defSelect && self.merchantList.length > 0) {
                            self.merchantId = self.merchantList[0].id;
                            self.merchantChange();
                        } else if(!Utils.isNoB(self.merchantId) && self.merchantList.length > 0) {
                            self.merchantChange();
                        }
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            merchantChange(){
                if (typeof this.selectHandler == 'function') {
                    let merchantId = this.merchantId;
                    let merchant = this.merchantList.find(function (item) {
                        return item.id == merchantId;
                    });
                    this.merchant = merchant;
                    this.selectHandler.call(null, merchant);
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/merchant/MerchtSelectPopover.vue